const sectionSelector = '#MainContent > .shopify-section:not(:first-child)';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const revealImmediately = (section) => {
  section.classList.add('gimoka-reveal', 'is-visible');
};

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        },
        {
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.06,
        }
      )
    : null;

const prepareSection = (section) => {
  if (!(section instanceof HTMLElement) || section.matches(':first-child')) return;

  if (reducedMotion.matches || !observer) {
    revealImmediately(section);
    return;
  }

  section.classList.add('gimoka-reveal');
  observer.observe(section);
};

document.documentElement.classList.add('gimoka-reveal-ready');
document.querySelectorAll(sectionSelector).forEach(prepareSection);

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.closest?.('.shopify-section') ?? event.target;
  prepareSection(section);
});

reducedMotion.addEventListener('change', (event) => {
  if (!event.matches) return;

  document.querySelectorAll(`${sectionSelector}.gimoka-reveal`).forEach((section) => {
    observer?.unobserve(section);
    revealImmediately(section);
  });
});
